import { FarmapromPharmaciesModal } from '@components/farmapromPharmacies/FarmapromPharmaciesModal';
import { UMXPharmaciesModal } from '@components/umx/UMXPharmaciesModal';
import { useRootData } from '@hooks/hook';
import { PharmacyEditDto } from '@services/commandMappers/Pharmacy';
import { DictionariesConstants } from '@services/DictionariesConstants';
import {
	CreatePharmacyCommand,
	FarmapromPharmacyDto,
	ProductBrand,
	UmxPharmacyDto,
	UpdatePharmacyCommand,
} from '@services/src/models';
import { Card, Col, Divider, Row, Space } from 'antd';
import { Field, Formik, FormikProps } from 'formik';
import { DictionarySelect } from 'forms/DictionarySelect';
import {
	FDatePicker,
	FFieldLabel,
	FInput,
	FInputNumber,
} from 'forms/FormikFormItems';
import React from 'react';
import { IDictionaryStore } from 'stores/DictionaryStore';

import { IdentifiersModal } from '../identifiers/IdentifiersModal';
import styles from '../styles/PharmacyEdit.module.less';

interface IProps {
	readOnly: boolean;
	updateView: boolean;
	formikProps: FormikProps<
		CreatePharmacyCommand | UpdatePharmacyCommand | PharmacyEditDto
	>;
}

export const InternalData = (props: IProps) => {
	const dictionaryStore: IDictionaryStore = useRootData(
		(store) => store.dictionaryStore
	);

	const pharmacyNhfContractId = dictionaryStore.getItemCodeNameById(
		DictionariesConstants.NHFContract,
		props.formikProps.values.nhfContractId!
	);

	const nhfContractIds = ['CONTRACTED', 'TO_EXTINCTION'];

	return (
		<Col span={12}>
			<h2 className="header-text">Internal data</h2>

			<div className={styles.description}>
				<Row>
					<Col span={12}>
						<div className="fieldbox">
							<FFieldLabel label="SAP ID" />
							<Field
								component={FInput}
								placeholder="SAP ID"
								name="placeId"
								readOnly={true}
							/>
						</div>
					</Col>
					<Col span={11} offset={1}>
						<Space direction="horizontal">
							<div className="fieldbox">
								<FFieldLabel label="Kod Kom" />
								<Field
									component={FInputNumber}
									placeholder="Kod Kom"
									name="kodKom"
									precision={0}
									readOnly={true}
								/>
							</div>
							<UMXPharmaciesModal
								disabled={props.readOnly || !props.updateView}
								voivodeshipId={
									props.formikProps.values.voivodeshipId!
								}
								onPharmacySelect={(
									pharmacy: UmxPharmacyDto
								) => {
									console.log('Selected pharmacy from UMX modal:', pharmacy);
									if (pharmacy.productBrand == ProductBrand.Tena) {
										props.formikProps.setFieldValue(
											'identifierTena',
											pharmacy.identifier
										);

									}
									if (pharmacy.productBrand == ProductBrand.Actimove) {
										props.formikProps.setFieldValue(
											'identifierActimove',
											pharmacy.identifier
										);
									}


									props.formikProps.setFieldValue(
										'kodKom',
										pharmacy.kodKom
									);

									props.formikProps.setFieldValue(
										'login',
										pharmacy.technicalCode
									);

									props.formikProps.setFieldValue(
										'healthFundID',
										pharmacy.healthFundID
									);

									const contractedValueDto = dictionaryStore.getValueByCodeName(
										DictionariesConstants.NHFContract,
										'CONTRACTED'
									);

									if (contractedValueDto?.id) {
										props.formikProps.setFieldValue(
											'nhfContractId',
											contractedValueDto?.id
										);
									}
								}}
							/>
						</Space>
					</Col>
				</Row>

				<Row>
					<Col span={12}>
						<div className="fieldbox">
							<FFieldLabel label="Health Fund ID" />
							<Field
								component={FInput}
								placeholder="Health Fund ID"
								name="healthFundID"
								readOnly={true}
							/>
						</div>
					</Col>
					<Col span={11} offset={1}>
						<Space direction="horizontal">
							<div className="fieldbox">
								<FFieldLabel label="FP ID" />
								<Field
									component={FInput}
									placeholder="FP ID"
									name="farmapromPharmacyId"
									readOnly={true}
								/>
							</div>
							<FarmapromPharmaciesModal
								disabled={props.readOnly}
								onPharmacySelect={(
									pharmacy: FarmapromPharmacyDto | null
								) => {
									if (pharmacy) {
										props.formikProps.setFieldValue(
											'farmapromPharmacyId',
											pharmacy.farmapromPharmacyId
										);
										props.formikProps.setFieldValue(
											'name',
											pharmacy.name
										);
										props.formikProps.setFieldValue(
											'street',
											pharmacy.street
										);
										props.formikProps.setFieldValue(
											'city',
											pharmacy.city
										);
										props.formikProps.setFieldValue(
											'postalCode',
											pharmacy.postalCode
										);
										props.formikProps.setFieldValue(
											'voivodeshipId',
											pharmacy.voivodeshipId
										);
										props.formikProps.setFieldValue(
											'district',
											pharmacy.district
										);
										props.formikProps.setFieldValue(
											'salesRepresentative',
											pharmacy.salesRepresentative
										);
										props.formikProps.setFieldValue(
											'pharmacyChain',
											pharmacy.pharmacyChain
										);
										props.formikProps.setFieldValue(
											'kam',
											pharmacy.kam
										);
									} else {
										props.formikProps.setFieldValue(
											'farmapromPharmacyId',
											undefined
										);
									}
								}}
							/>
						</Space>
					</Col>
				</Row>

				<Row>
					<Col span={12}>
						<div className="fieldbox">
							<FFieldLabel label="Login" />
							<Field
								component={FInput}
								placeholder="Login"
								name="login"
								readOnly={true}
							/>
						</div>
					</Col>


				</Row>
				{/* <Row>
					<Col span={12}>
						<div className="fieldbox">
							<FFieldLabel label="Business continuity" />
							<Field
								component={FInput}
								placeholder="Business continuity"
								name="businessContinuity"
								readOnly={props.readOnly}
							/>
						</div>
					</Col>
				</Row> */}
				<Card style={{ marginTop: 16, marginBottom: 16 }}>
					<Divider orientation="left" style={{ marginTop: 0 }}>
						TENA
					</Divider>
					<Row>
						<Col span={12}>
							<div className="fieldbox">
								<FFieldLabel label="NHF TENA" />
								<DictionarySelect
									readOnly={props.readOnly}
									formikProps={props.formikProps}
									formikName="nhfContractId"
									dictionaryCodeName={
										DictionariesConstants.NHFContract
									}
									disabledCodes={
										props.formikProps.values instanceof
											PharmacyEditDto &&
											pharmacyNhfContractId &&
											!nhfContractIds.includes(
												pharmacyNhfContractId
											) &&
											props.formikProps.values
												.isPharmacyHasNhfContract
											? nhfContractIds
											: []
									}
								/>
							</div>
						</Col>

						<Col span={11} offset={1}>
							<div className="fieldbox">
								<FFieldLabel label="Date of joining the chain" />
								<Field
									label="Date of joining TENA chain"
									component={FDatePicker}
									style={{ width: '100%' }}
									name="dateOfJoiningEssityNet"
									mode="date"
									disabled={props.readOnly}
								/>
							</div>
						</Col>
					</Row>

					<Row>

						<Col span={12}>
							<div className="fieldbox">
								<FFieldLabel label="Paper contract number" />
								<Field
									component={FInput}
									placeholder="Paper contract number"
									name="essityPaperContractNumber"
									readOnly={props.readOnly}
								/>
							</div>
						</Col>
						<Col span={11} offset={1}>
							<div className="fieldbox">
								<FFieldLabel label="End contract reason" />
								<DictionarySelect
									readOnly={props.readOnly}
									formikProps={props.formikProps}
									formikName="endContractReasonId"
									dictionaryCodeName={
										DictionariesConstants.EndContractReason
									}
								/>
							</div>
						</Col>
					</Row>

					<Row>
						<Col span={12}>
							<div className="fieldbox">
								<FFieldLabel label="End date of contract" />
								<Field
									label="End date of TENA contract"
									component={FDatePicker}
									name="endDateOfEssityContract"
									mode="date"
									style={{ width: '100%' }}
									disabled={props.readOnly}
								/>
							</div>
						</Col>
						<Col span={11} offset={1}>
							<Space direction="horizontal">
								<div className="fieldbox">
									<FFieldLabel label="Dist.number (wyroznik)" />
									<Field
										component={FInputNumber}
										placeholder="Dist.number (wyroznik)"
										name="identifierTena"
										precision={0}
										readOnly={true}
									/>
								</div>

								<IdentifiersModal
									disabled={props.readOnly || !props.updateView}
									voivodeshipId={
										props.formikProps.values.voivodeshipId
									}
									kodKom={props.formikProps.values.kodKom}
									productBrand={ProductBrand.Tena}
								/>
							</Space>
						</Col>

					</Row>
				</Card>
				<Card>
					<Divider orientation="left" >
						ACTIMOVE
					</Divider>

					<Row>
						<Col span={12}>
							<div className="fieldbox">
								<FFieldLabel label="NHF ACTIMOVE" />
								<DictionarySelect
									readOnly={props.readOnly}
									formikProps={props.formikProps}
									formikName="actimoveContractId"
									dictionaryCodeName={
										DictionariesConstants.NHFContract
									}
									disabledCodes={
										props.formikProps.values instanceof
											PharmacyEditDto &&
											pharmacyNhfContractId &&
											!nhfContractIds.includes(
												pharmacyNhfContractId
											) &&
											props.formikProps.values
												.isPharmacyHasNhfContract
											? nhfContractIds
											: []
									}
								/>
							</div>
						</Col>

						<Col span={11} offset={1}>
							<div className="fieldbox">
								<FFieldLabel label="Date of joining the chain" />
								<Field
									label="Date of joining ACTIMOVE chain"
									component={FDatePicker}
									style={{ width: '100%' }}
									name="dateOfJoiningActimoveNet"
									mode="date"
									disabled={props.readOnly}
								/>
							</div>
						</Col>
					</Row>

					<Row>
						<Col span={12}>
							<div className="fieldbox">
								<FFieldLabel label="Paper contract number" />
								<Field
									component={FInput}
									placeholder="Paper contract number"
									name="actimovePaperContractNumber"
									readOnly={props.readOnly}
								/>
							</div>
						</Col>

						<Col span={11} offset={1}>
							<div className="fieldbox">
								<FFieldLabel label="End contract reason" />
								<DictionarySelect
									readOnly={props.readOnly}
									formikProps={props.formikProps}
									formikName="endContractActimoveReasonId"
									dictionaryCodeName={DictionariesConstants.EndContractReason}
								/>
							</div>
						</Col>
					</Row>

					<Row>
						<Col span={12}>
							<div className="fieldbox">
								<FFieldLabel label="End date of contract" />
								<Field
									label="End date of ACTIMOVE contract"
									component={FDatePicker}
									name="endDateOfActimoveContract"
									mode="date"
									style={{ width: '100%' }}
									disabled={props.readOnly}
								/>
							</div>
						</Col>
						<Col span={11} offset={1}>
							<Space direction="horizontal">
								<div className="fieldbox">
									<FFieldLabel label="Dist.number (wyroznik)" />
									<Field
										component={FInputNumber}
										placeholder="Dist.number (wyroznik)"
										name="identifierActimove"
										precision={0}
										readOnly={true}
									/>
								</div>

								<IdentifiersModal
									disabled={props.readOnly || !props.updateView}
									voivodeshipId={
										props.formikProps.values.voivodeshipId
									}
									kodKom={props.formikProps.values.kodKom}
									productBrand={ProductBrand.Actimove}
								/>
							</Space>
						</Col>
					</Row>
				</Card>
			</div>
		</Col>
	);
};
